<div class="questionnaire-container">
  <!-- Help Text (Left Side) -->
  <div class="help-text">
    <h3>{{ copy.heading }}</h3>
    <p>
      {{ copy.instructionsBefore }} <strong>‘{{ copy.submitLabel }}’</strong>
      {{ copy.instructionsAfter }}
    </p>
  </div>

  <!-- Questions Section (Right Side) -->
  <div class="questions-section" >
    <div>
      @if ((isLoadingQuestionnaire || isLoadingResponses)) {
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>{{ copy.loadingQuestions }}</p>
      </div>
      } @else if (isSavingResponses){
      <div class="loading-spinner">
        <div class="spinner"></div>
        <p>{{ copy.savingResponses }}</p>
      </div>
      } @else if (hasCompleted){
      <div class="text-center">
        <i
          class="bi bi-check-circle-fill text-success"
          style="font-size: 4rem"
        ></i>
        <p class="mt-3">
          {{ copy.savedSuccess }}
        </p>
        <p class="mt-5 redirect-text">
          {{ copy.redirectingBefore }}
          <span id="redirect-timer">{{ this.redirectTime }}</span>
          {{ copy.redirectingAfter }}
        </p>
      </div>
      } @else if (errorMessage) {
      <div class="error-message">
        <i class="bi bi-exclamation-circle-fill error-icon"></i>
        <p class="error-heading">{{ copy.errorHeading }}</p>
        <p>{{ errorMessage }}</p>
      </div>
      } @else {
      <app-questions
      
      (formInstance)="onFormInstanceCaptured($event)"
      [questionnaire]="questionnaire"
      [questionnaireType]="'initial'"
      [isLoadingQuestionnaire]="isLoadingQuestionnaire"
      [isSavingResponses]="isSavingResponses"
      [hasCompleted]="hasCompleted"
      [errorMessage]="errorMessage"
      [explanationText]="copy.explanationText"
      [submitButtonText]="copy.submitLabel"
      [adjustingQuestionsText]="copy.adjustingQuestions"
      (formSubmit)="onSubmit($event)"
      ></app-questions>
      }
    </div>
  </div>
  
  <!-- Scroll indicator -->
  <button
    class="scroll-indicator"
    *ngIf="isContentScrollable"
    (click)="scrollDown()"
    aria-label="Scroll down"
  >
    <i class="bi bi-chevron-down"></i>
  </button>
</div>
